import { OperationEnum, OperationsMapper } from '../types';
import { useIsOperation } from './operations';
import { BooleanOperationPayload } from './types';

export * from './operations';
export * from './sanitizers';

export const BooleanOperationsMapper: OperationsMapper = {
  [OperationEnum.Is]: (value) => useIsOperation(value as BooleanOperationPayload),
};
